enum PlatformCoreUserFilterType {
    CORE_USER_TEAMS = 'CORE_USER_TEAMS',
    CORE_USER_ROLES = 'CORE_USER_ROLES',
    CORE_USER_VERIFIED = 'CORE_USER_VERIFIED',
    CORE_USER_ARCHIVED = 'CORE_USER_ARCHIVED',
}

export default PlatformCoreUserFilterType;
